import { Trans, t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { ArrowLeft, X } from "lucide-react";

interface ConfirmScreenProps {
  amount: string;
  assetName: string;
  onBack: () => void;
  onClose: () => void;
  onConfirm: () => void;
}

export function ConfirmScreen({ amount, assetName, onBack, onClose, onConfirm }: ConfirmScreenProps) {
  useLingui();
  return (
    <div className="mt-[60px] flex  flex-col px-4 py-6 md:px-8 md:py-10">
      <div className="mx-auto mb-65 w-full max-w-screen-md">
        <button
          onClick={onBack}
          className="py-2.5 hover:bg-muted flex w-fit items-center gap-2 rounded-full bg-[#1E1E1F] px-10 py-6 text-[16px] text-[#ffff6] ring-1 ring-[#fff56] transition-colors hover:ring-[#FFF] md:text-[20px]"
          aria-label={t`Go back`}
        >
          <ArrowLeft />
          <Trans>Back</Trans>
        </button>
      </div>

      <div className="mx-auto -mt-10 flex w-full max-w-screen-md flex-col items-center justify-center gap-10 md:gap-25">
        <h1 className="text-foreground mb-10 text-balance text-center text-34 font-bold md:text-40"><Trans>Confirm amount</Trans></h1>

        <div className="mt-10 text-center md:mt-16">
          <p className="text-[14px] text-[#ffffff66] md:text-[16px]"><Trans>Total amount</Trans></p>
          <p className="mt-2 font-mono text-[24px] font-bold text-[#00EC97] md:text-24">
            {amount} {assetName}
          </p>
        </div>

        <p className="leading-relaxed md:leading-8 mt-8 text-pretty text-center text-[14px] font-medium text-[#ffff] md:text-[24px]">
          <Trans>Will be transferred from Base to Asset Chain into your Nectarliquid balance</Trans>
        </p>

        <div className="mt-12 flex w-full flex-col items-center md:mt-16">
          <p className="text-foreground text-sm md:text-base mb-4 font-medium"><Trans>Would you like to proceed?</Trans></p>
          <button
            onClick={onConfirm}
            className="mx-auto mt-20 h-[64px] w-[304px] rounded-full bg-[#00EC97] text-14 font-semibold text-black transition-all hover:brightness-110 active:scale-[0.98] md:text-24"
          >
            <Trans>Yes, proceed</Trans>
          </button>
          <p className="mt-12 text-[12px] text-[#A2A2A2] md:text-[15px]"><Trans>Network fees: $0.3</Trans></p>
        </div>
      </div>
    </div>
  );
}
